var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "规则名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入规则名称" },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "预警类型",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "warnType"
                          }
                        },
                        [
                          _c("j-multi-select-tag", {
                            attrs: {
                              type: "list_multi",
                              dictCode: "pre_send_type",
                              placeholder: "请选择预警类型"
                            },
                            model: {
                              value: _vm.model.warnType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "warnType", $$v)
                              },
                              expression: "model.warnType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "时间单位",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "detectionUnit"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "pre_time_type",
                              placeholder: "请选择时间单位"
                            },
                            on: { change: _vm.detectionUnitChange },
                            model: {
                              value: _vm.model.detectionUnit,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "detectionUnit", $$v)
                              },
                              expression: "model.detectionUnit"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "核酸时间配置",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "detectionTime"
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "50%" },
                            attrs: {
                              placeholder: "请输入核酸时间配置",
                              suffix: _vm.timeType
                            },
                            model: {
                              value: _vm.model.detectionTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "detectionTime", $$v)
                              },
                              expression: "model.detectionTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "提前预警时间",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "beforeWarnTime"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            staticStyle: { width: "50%" },
                            attrs: {
                              type: "list",
                              dictCode: "pre_before_hour",
                              placeholder: "请选择提前预警时间"
                            },
                            model: {
                              value: _vm.model.beforeWarnTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "beforeWarnTime", $$v)
                              },
                              expression: "model.beforeWarnTime"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                position: "absolute",
                                right: "30px"
                              }
                            },
                            [_vm._v("小时")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "厂区-区域-楼栋",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "treeData"
                          }
                        },
                        [
                          _c("a-tree-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "tree-data": _vm.treeData,
                              "tree-checkable": "",
                              "allow-clear": "",
                              "show-checked-strategy": _vm.SHOW_PARENT,
                              placeholder: "请选择厂区-区域-楼栋"
                            },
                            on: {
                              treeExpand: _vm.handlerTreeExpand,
                              change: _vm.handlerChange,
                              select: _vm.handlerSelect
                            },
                            model: {
                              value: _vm.model.treeData,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "treeData", $$v)
                              },
                              expression: "model.treeData"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "是否启用",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "status"
                          }
                        },
                        [
                          _c("j-switch", {
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }